import React from 'react';
import VisitList from '../components/VisitList';
//import './VisitsPage.css';

const VisitsPage = () => {
  return (
    <div className="visits-page">
      <div className="page-header">
        <h1>Visit Management</h1>
        <p className="page-description">
          Manage patient visits, schedule appointments, and record vitals
        </p>
      </div>
      
      <div className="page-content">
        <VisitList />
      </div>
    </div>
  );
};

export default VisitsPage;